import "./util.js";
import viewer from "./module.js";
delete window["pdfjs-dist/build/pdf"];
export default viewer;